<template>
  <div class="boxs">
      <div class="boxs_title">
        <span>创建</span>
        <img src="@/assets/xxx.png" alt="" @click="fanhui">
      </div>
      <div class="content_boxs">
        <div class="box">
        <div class="title_tabs">
          <div :class="index=='1'?'active':''">产品详情</div>
          <div :class="index=='2'?'active':''">价格设置</div>
          <div :class="index=='3'?'active':''">场次设置</div>
        </div>
        <div class="form_box">
          <el-form ref="formName" :rules="formRules"  :model="form" label-width="140px" v-if="index==1">
            <el-form-item label="演出名称："  prop="movie_name">
              <el-input v-model="form.movie_name" placeholder="请输入内容" maxlength="15"></el-input>
            </el-form-item>
            <div class="flex">
              <el-form-item label="分类：" prop="type">
                <el-select v-model="form.type" clearable filterable  placeholder="请选择">
                    <el-option
                      v-for="item in option"
                      :key="item.id"
                      :label="item.type_name"
                      :value="item.id">
                    </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="实名制购票：" prop="is_idcard">
                <el-radio-group v-model="form.is_idcard">
                  <el-radio label="1">实名制</el-radio>
                  <el-radio label="2">不记名</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <el-form-item label="是否退票：" prop="is_refund">
                <div class="ali_items"> 
                  <el-radio-group v-model="form.is_refund">
                    <el-radio label="2">否</el-radio>
                    <el-radio label="1">可退</el-radio>
                  </el-radio-group>
                  <span style="margin-left:2rem;" v-if="form.is_refund==1">开演前</span>
                  <el-input  oninput ="value=value.replace(/[^0-9.]/g,'')" v-if="form.is_refund==1" v-model="form.minute" placeholder="请输入"></el-input>
                  <span v-if="form.is_refund==1">时</span>
                </div>
            </el-form-item>
            <el-form-item label="演出场地示意图：" prop="site_img">
              <div class="flex">
                <el-upload
                  class="avatar-uploader"
                  action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                  :show-file-list="false"    
                  :on-success="attachUploadSuccess"
                  :data="datas"  
                  >
                  <img v-if="form.site_img" :src="form.site_img" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <span>注：如不需要场地示意图，可放置场馆环境照片</span>
              </div>
              
            </el-form-item>
            <el-form-item label="详情：" >
              <div class="proA">
                <quill-editor 
                  v-model="form.info" 
                  ref="myQuillEditor" 
                  :options="editorOption"
                >
              </quill-editor>
              </div>
            </el-form-item>
            <el-form-item label="须知：">
              <div class="proA">
                <quill-editor 
                  v-model="form.notice" 
                  ref="myQuillEditor" 
                  :options="editorOption"
                >
              </quill-editor>
              </div>
            </el-form-item>
            <el-form-item label="发票开具说明：" >
              <quill-editor 
                v-model="form.invoice" 
                ref="myQuillEditor" 
                :options="editorOption"
              >
              </quill-editor>
            </el-form-item>
            <el-form-item label="演出封面：" prop="img">
                <div class="flex">
                  <!-- <el-upload
                    class="avatar-uploader"
                    action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                    :show-file-list="false"    
                    :on-success="attachUploadimg"
                    :data="datas"  
                    >
                    <img v-if="form.img" :src="form.img" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload> -->
                  <cutImageDialog :imgs="form.img" @resurl="resurl" v-if="imsgflow"  />
                  <span>注：请上传1M以下的图片(此图片用于平台宣传，请认真对待)，
    支持png、jpg、jpeg</span>
                </div>
            </el-form-item>
            <el-form-item label="演出现场" >
              <el-upload action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                :limit="5"
                :on-success="attachUpload"
                :data="datas"
                 list-type="picture-card"
                ref="pictureUpload"
                :file-list="transDetImgList">
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{file}">
                    <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                    <span class="el-upload-list__item-actions">
                      <span
                        v-if="!disabled"
                        class="el-upload-list__item-delete"
                        @click="handleRemove(file)"
                      >
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
              </el-upload>
            </el-form-item>
            <div class="flex_state" >
              <el-form-item label="状态："  prop="status">
                  <el-radio-group v-model="form.status">
                    <el-radio label="1">上线</el-radio>
                    <el-radio label="2">暂不上线</el-radio>
                  </el-radio-group>
              </el-form-item>
              <span>注：默认为允许销售，下线则不允许销售</span>
            </div>
            <!-- <el-form-item label="上架途径：" >
              <el-checkbox-group v-model="form.status">
                <el-checkbox label="小程序"></el-checkbox>
                <el-checkbox label="自营微商城"></el-checkbox>
              </el-checkbox-group>
            </el-form-item> -->
          </el-form>
          <div v-if="index==3">
              <div class="index_two_box" v-for="(item,index) in showtimes" :key="index">
                <div class="times">
                  <span>场次时间：</span>
                <el-time-select
                  :class="index==0?'active_showtimes':''"
                  placeholder="起始时间"
                  value-format="HH:mm"
                  v-model="item.time"
                  :picker-options="{
                    start: '00:00',
                    step: '00:15',
                    end: '23:59'
                  }">
                </el-time-select>
                  <span v-if="index>0" style="margin-left:2rem;color:red;     cursor: pointer;" @click="deteleShow(item,index)">删除</span>
                </div>
                <div class="cheche_box">
                  <div class="text">
                    营业区域：
                  </div>
                  <div class="checkbox_true">
                    <!-- <el-checkbox-group v-model="item.movie_area_ids"  @click="handleCheckedCitiesChange">
                      <el-checkbox v-for="(itm,index) in tableData"  :label="itm.id" :key="itm.id">{{itm.id}}{{itm.area_name}}</el-checkbox>
                    </el-checkbox-group> -->
                    <!-- <el-checkbox-group v-model="item.movie_area_ids"  v-for="(itm,index) in tableData" :key="index">
                        <el-checkbox  :label="itm.area_name">{{itm.area_name}}</el-checkbox>
                    </el-checkbox-group> -->
                    <el-select v-model="item.movie_area_ids" clearable multiple placeholder="请选择" @change="select(item.movie_area_ids)">
                      <el-option
                        v-for="item in tableData"
                        :key="item.area_id"
                        :label="item.area_name"
                        :value="item.area_id">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="cheche_box">
                  <div class="text">价格设定：</div>
                  <div class="radio_box ali_items">
                    <el-radio-group v-model="item.price_set" @change="chageRadios"> 
                      <el-radio label="1">原价</el-radio>
                      <el-radio label="2">增幅</el-radio>
                    </el-radio-group>
                    <el-input v-model="item.pct"  oninput ="value=value.replace(/[^0-9.]/g,'')" placeholder="请输入"></el-input>
                    <span class="baifen">%</span>
                    <span class="total">注：价格设定是指本场次的价格</span>
                  </div>
                </div>
              </div>
              <div class="addcc">
                  <div @click="addcang">添加场次</div>
              </div>
          </div>
        </div>
        </div>
        <div class="index_two" v-if="index==2&&!flow">
          <div class="two_btns">
            <div @click="addregion">添加区域</div>
            <!-- <div>删除</div> -->
          </div>
          <div class="table_box">
            <el-table
              :data="tableData"
              :header-cell-style="tableHeaderColor"
              :cell-style="cellStyle"
              style="width: 100%"
              ref="multipleTable"
            >
              
              <el-table-column prop="area_name" label="区域名称"></el-table-column>
              <el-table-column  label="操作">
                <template slot-scope="scope">
                    <div class="operation">
                      <div class="add_bianji" @click="opmeFlow(scope.row)">价格设置</div>
                      <div class="detele" @click="detele(scope.row,$index)">删除</div>
                    </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="position" v-if="index==2&&flow">
          <div>
            <div class="position_box">
              <div class="title_name">
                <img src="@/assets/ge.png" alt="">
                <span>舞台方向 {{item.area_type}}</span>
              </div>
              <div class="content" v-if="item.area_type==1">
                <div class="absolute">
                  <div v-for="(item,idx) in aboutIndex" :key="idx" >
                    {{idx}}
                  </div>
                </div>
                <div v-for="(item,idx) in aboutIndex" :key="idx" class="gezi_boxs">
                  <div v-for="(itm,index) in item"  :class="[itm.act==2?'already':itm.act=='3'?'SelectCss':'',itm.id?'':'active_id']" :key="index" @click="changeClick(itm)">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.area_type!=1">
            <div class="names">
              <span>区域名称：</span>
              <el-input v-model="info.area_name" disabled></el-input>
            </div>
            <div style="margin-top:2rem;" class="names" v-if="item.area_type==2"> 
              <span>设置价格：</span>
              <el-input v-model="room_price" ></el-input>
              <span>元</span>
            </div>
            <div style="margin-top:2rem;" class="names" v-if="item.area_type==3"> 
              <span>设置价格：</span>
              <el-input v-model="people_price" ></el-input>
              <span>元</span>
            </div>
            <div class="btns" >
                <div @click="closeAreaid">返回</div>
                <div @click="areaidsBtns">确认保存</div>
            </div>
          </div>
          <div v-if="item.area_type==1">
              <div class="names">
                <span>区域名称：</span>
                <el-input v-model="info.area_name" disabled></el-input>
              </div>
              <div class="types">
                <span>设置类别：</span>
                <div class="ali_items">
                  <div><el-radio v-model="radio" label="0" @change="quanxuan">自定义</el-radio></div>
                  <!-- <div><el-radio v-model="radio" label="2">按横排自定义</el-radio></div> -->
                  <div><el-radio v-model="radio" label="1" @change="quanxuan">全选</el-radio>
                    <el-input v-model="price"  v-if="radio==1"></el-input>
                    <span  v-if="radio==1">元</span>
                  </div>
                </div>
              </div>
              <div class="nums" v-if="radio==0">
                <span>自定义价格：</span>
                <el-input v-model="zdyPrice" ></el-input>
                <span class="yuan">元</span>
                <div class="nums_btns" @click="handleSubmit">
                  确认
                </div>
              </div>
              <div class="btns" style="margin-top:1rem;">
                <div @click="closeAreaid">返回</div>
                <div @click="areaidsBtns">确认保存</div>
              </div>
          </div>
        </div>
        <div class="button_btns" v-if="!flow">
          <div @click="step" v-show="index!=1">{{nxt}}</div>
          <div @click="next">{{text}}</div>
        </div>
        <el-dialog :close-on-click-modal="false"
          title="添加区域"
          :visible.sync="Visible"
          :before-close="Close"
          width="20.6%"
          center
          top="30vh"
        >
          <el-divider></el-divider>
          <div class="RechargeContent">
            <el-form ref="form" :model="form" label-width="90px">
              <div class="RechargeItem">
                <el-form-item label="区域名称：">
                  <el-select v-model="areaidsName" clearable filterable  placeholder="请选择区域">
                      <el-option
                        v-for="item in areaOption"
                        :key="item.id"
                        :label="item.area_name"
                        :value="item.id">
                      </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="itemBtnS" >
                  <div @click="Close">取消</div>
                  <div @click="addTypeSucc">完成</div>
              </div>
            </el-form>
          </div>
        <!-- 分页结束 -->
        </el-dialog>
      </div>
  </div>
</template>
<script>
import { getMovieTypeList , getMovieAreaList , getMovieAreaInfo , addMovie , getMovieInfo , updateMovie } from '@/request/scenic.js'
import cutImageDialog from '@/assets/place.vue'
import { Message } from 'element-ui'
export default {
  components: { cutImageDialog },
  data(){
    return{
      editorOption: {
        placeholder: "请在这里输入",
        modules:{
          toolbar:[
              ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'],     //引用，代码块
              [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
              [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下标
              [{ 'indent': '-1'}, { 'indent': '+1' }],     // 缩进
              [{ 'direction': 'rtl' }],             // 文本方向
              [{ 'color': [] }, { 'background': [] }],     // 字体颜色，字体背景颜色
              [{ 'align': [] }],    //对齐方式
              ['clean'],    //清除字体样式
            ]
        }
      },
      nxt:'返回',
      text:'下一步',
      index:1,
      form:{
        // 
        token:window.sessionStorage.getItem('Token'),
        movie_name:'',// 演出名称
        type:'', // 分类
        is_idcard:'1',
        is_refund:'1',
        minute:'',
        site_img:'',
        img:'',
        status:'1',
        info:'<p>【演出介绍】：</p>\r\n\t\t\t\t\t\t\t<p>【重要提示】：</p>\r\n\t\t\t\t\t\t\t<p>【VIP权益】：</p>\r\n\t\t\t\t\t\t\t', // 产品描述
        notice:'<p>【购票须知】：</p>\r\n\t\t\t\t\t\t\t<p>【观影须知】：</p>\r\n\t\t\t\t\t\t\t<p>【退票须知】：</p>\r\n\t\t\t\t\t\t\t', // 产品描述
        invoice:'',
        imgs:[],
        areaids:[],
        showtimes:[]
      },
      formRules:{
        movie_name: [{ required: true, message: '请输入演出名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择分类', trigger: 'change' }],
        is_idcard: [{ required: true, message: '请选择实名制', trigger: 'change' }],
        is_refund: [{ required: true, message: '请选择是否可退', trigger: 'change' }],
        site_img: [{ required: true, message: '请上传场地示意图', trigger: 'change' }],
        img: [{ required: true, message: '请上传封面', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],

      },
      radio:'0',
      checkList:[],
      datas:{
        token:window.sessionStorage.getItem('Token')
      },
      option:[],
      fileList:'',
      transDetImgList:[],
      lowerIndex:10,
      aboutIndex:[],
      flow:false,
      tableData:[],
      Visible:false,
      disabled:false,
      areaOption:[],
      areaidsName:'',
      ids:'',
      info:'',
      price:'',
      nums:0,
      zdyPrice:'',
      optionArr:[],
      areaids:[],
      item:'',
      room_price:'',
      people_price:'',
      showtimes:[
        {
          time:'',
          movie_area_ids:[],
          price_set:'1',
          pct:''
        }
      ],
      imsgflow:false,
      movie_area_idSeve:'',
      openFlow:false
    }
  },
  created(){
    let data = {
      token:window.sessionStorage.getItem('Token'),
      page:1,
      page_size:999
    }
    getMovieTypeList(data).then(res=>{
      if(res.data.status=='ok'){
        this.option = res.data.result.data
      }
    })
    getMovieAreaList(data).then(res=>{
      if(res.data.status=='ok'){
          this.areaOption = res.data.result.data
      }
    })
    if(this.$route.query.id){
      let datas = {
        token:window.sessionStorage.getItem('Token'),
        id:this.$route.query.id
      }
      getMovieInfo(datas).then(res=>{
        if(res.data.status=='ok'){
          this.form={
            // 
            token:window.sessionStorage.getItem('Token'),
            movie_name:res.data.result.movie_name,// 演出名称
            type:res.data.result.type, // 分类
            is_idcard:res.data.result.is_idcard + '',
            is_refund:res.data.result.is_refund + '',
            minute:res.data.result.is_refund==1?res.data.result.minute:0,
            site_img:res.data.result.site_img,
            img:res.data.result.img,
            status:res.data.result.status + '',
            info:res.data.result.info, // 产品描述
            notice:res.data.result.notice, // 产品描述
            invoice:res.data.result.invoice,
          }
          this.form.imgs = res.data.result.imgs.split(',')
          this.transDetImgList = this.form.imgs;
          if(this.form.img){
            this.imsgflow = true
          }
          if(res.data.result.area.length!=0){
            this.tableData = res.data.result.area
            getMovieAreaList(data).then(resn=>{
              if(resn.data.status=='ok'){
                if(this.tableData.length!=0){
                  let list = resn.data.result.data
                  for(let i=0;i<list.length;i++){
                    for(let j=0;j<this.tableData.length;j++){
                        if(this.tableData[j].area_id==list[i].id){
                          list.splice(i,1);
                        }
                    }
                  }
                  this.areaOption  = list
                }else{
                  this.areaOption = res.data.result.data
                }
              }
            })
          }
          if(res.data.result.imgs){
            let img = []
            res.data.result.imgs.split(',').map(item=>{
              img.push({
                url:item
              })
            })
            this.transDetImgList = img
          }
          if(res.data.result.area.length!=0){
            this.form.areaids = []
            res.data.result.area.map(item=>{
              let data = {
                movie_area_id:item.area_id,
                is_check_all:item.is_check_all?item.is_check_all:0,
                area_type:item.area_type,
                room_price:item.area_type==2?item.room_price:'',
                people_price:item.area_type==3?item.people_price:'',
                seats:[]
              }
            // this.optionArr
            if(item.seats){
              item.seats.map(itm=>{
                data.seats.push({
                  movie_seats_id:itm.movie_seats_id?itm.movie_seats_id:'',
                  price:itm.price,
                  act: 3
                })
                itm.act = 3
              })
            }
            this.form.areaids.push(data)
          })
          }else{
             this.form.areaids = []
          }
          if(res.data.result.showtimes.length!=0){
            let option = []
            res.data.result.showtimes.map(item=>{
                let ids = []
                if(item.movie_area_ids!=''){
                  item.movie_area_ids.split(',').map(item=>{
                    let idnum = item 
                    ids.push(Number(idnum))
                  })
                }
                option.push({
                  time:item.time,
                  movie_area_ids:ids,
                  price_set:item.price_set + '',
                  pct:item.price_set==2?item.pct:''
                })
            })
            this.showtimes = option
          }
          this.$forceUpdate()
        }
      })
      if(this.$route.query.sort){
        this.index = this.$route.query.sort
        if(this.$route.query.sort==3){
          this.text = '保存'
          this.nxt = '上一步'
        }
        if(this.$route.query.sort==2){
          this.text = '下一步'
          this.nxt = '上一步'
        }
      }
    }else{
      this.imsgflow = true
    }
    
  
  },
  methods:{
    quanxuan(e){
      if(e==1){
        this.aboutIndex.map(item=>{
          item.map(im=>{
            im.act = 2
          })
        })
      }else{
        this.aboutIndex.map(item=>{
          item.map(im=>{
            im.act = 1
          })
        })
      }
      this.$forceUpdate()
    },
    step(){
      if(this.nxt=='返回'){
        this.$router.go(-1)
      }
      if(this.nxt=='上一步'&&this.index==2){
        this.index=1
      }
        if(this.index==3){
        this.index=2
        this.text = '下一步'
      }
    },
    deteleShow(item,index){
      this.showtimes.splice(index,1)
    },
    chageRadios(){
      this.$forceUpdate()
    },
    detele(row,index){
      this.tableData.map((item,index)=>{
        if(item.id==row.id){
          this.movie_area_idSeve  += row.area_id + ','
          this.tableData.splice(index,1)
        }
      })
      this.form.areaids.map((item,index)=>{
        if(item.movie_area_id==row.area_id){
          this.form.areaids.splice(index,1)
        }
      })
    },
    select(item){
        this.$forceUpdate()
    },
    addcang(){
      this.showtimes.push({
          time:'',
          movie_area_ids:[],
          price_set:'1',
          pct:''
      })
    },
    closeAreaid(){
      if(this.openFlow){
        this.tableData.splice(this.tableData.length-1,1)
      }else{

      }
      this.flow = false
    },
    areaidsBtns(){
      if(this.item.area_type==1){
        if(this.radio==0){
          for(let i=0;i<this.aboutIndex.length;i++){
            for(let j=0;j<this.aboutIndex[i].length;j++){
              if((this.aboutIndex[i][j].act==1||this.aboutIndex[i][j].act==2)&&this.aboutIndex[i][j].id){
                this.$message.error('自定义价格未设置完成或未确认价格')
                return false
              }
            }
          }
        }else{
          if(this.price==''){
            this.$message.error('请设置全选价格')
            return false
          }
          this.aboutIndex.map(item=>{
            item.map(itm=>{
              if(itm.id){
                this.optionArr.push({
                  movie_seats_id:itm.id,
                  price:this.price,
                  act: 3
                })
                itm.act = 3
              }
            })
            })
          }
      }
      let data = {}
      this.form.areaids.map(item=>{
        if(item.movie_area_id==this.ids){
            item.movie_area_id=this.ids
            item.is_check_all=this.radio
            item.area_type=this.item.area_type
            item.room_price=this.item.area_type==2?this.room_price:''
            item.people_price=this.item.area_type==3?this.people_price:''
            item.seats=this.optionArr
        }
      })
      for(let i=0;i<this.form.areaids.length;i++){
        if(this.form.areaids[i].movie_area_id==this.ids){
            // item.movie_area_id=this.ids
            // item.is_check_all=this.radio
            // item.area_type=this.item.area_type
            // item.room_price=this.item.area_type==2?this.room_price:''
            // item.people_price=this.item.area_type==3?this.people_price:''
            // item.seats=this.optionArr
            this.form.areaids.splice(i,1)
        }
      }
      data = {
        movie_area_id:this.ids,
        is_check_all:this.radio,
        area_type:this.item.area_type,
        room_price:this.item.area_type==2?this.room_price:'',
        people_price:this.item.area_type==3?this.people_price:'',
        seats:this.optionArr
      }
      this.form.areaids.push(data)
      this.flow = false
    },
    handleSubmit(){
      this.aboutIndex.map(item=>{
        item.map(itm=>{
          if(itm.act==2){
            this.optionArr.push({
              movie_seats_id:itm.id,
              price:this.zdyPrice,
              act: 3
            })
            itm.act = 3
          }
        })
      })
      this.zdyPrice = ''
      this.$forceUpdate()
    },
    opmeFlow(row){
      this.openFlow = false
      this.flow = true
      this.ids = row.area_id
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id:row.area_id
      }
      getMovieAreaInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.item = res.data.result
          this.info = res.data.result
          // this.aboutIndex
          for(let i=0;i<res.data.result.area_row;i++){
            this.aboutIndex[i] = []
            for(let j=0;j<res.data.result.area_column;j++){
              this.aboutIndex[i].push({
                act:1
              })
            }
          }
          this.aboutIndex.map((item,index)=>{
            item.map((info,idx)=>{
              res.data.result.movie_seats.map(movie=>{
                if(movie.column==idx+1&&movie.row==index+1){
                    info.act = 3
                    info.id = movie.id
                }
              })
            })
          })
        }
      })
    },
    addTypeSucc(){
      for(let i=0;i<this.tableData.length;i++){
        if(this.tableData[i].area_id==this.areaidsName){
          Message.error('该区域已添加')
          return false
        }
      }
      this.areaOption.map(item=>{
        if(item.id==this.areaidsName){
          item.area_id = item.id
          this.tableData.push(item)
          this.ids = item.id
          this.item = item
        }
      })
      let data = {
        token:window.sessionStorage.getItem('Token'),
        id:this.ids
      }
      getMovieAreaInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.info = res.data.result
          for(let i=0;i<res.data.result.area_row;i++){
            this.aboutIndex[i] = []
            for(let j=0;j<res.data.result.area_column;j++){
              this.aboutIndex[i].push({
                act:1
              })
            }
          }
          this.aboutIndex.map((item,index)=>{
            item.map((info,idx)=>{
              res.data.result.movie_seats.map(movie=>{
                if(movie.column==idx+1&&movie.row==index+1){
                    info.act = 1
                    info.id = movie.id
                }
              })
            })
          })
        }
      })
      this.flow = true
      this.Visible = false
      this.areaidsName = ''
      this.people_price = ''  
      this.room_price = '' 
      this.zdyPrice = ''
      this.price = ''
      this.radio = '0'
    },

    Close(){
      this.Visible = false
      this.areaidsName = ''
    },
    addregion(){
      this.openFlow = true
      this.Visible = true
    },
    handleSelectionChange(val){

    },
    fanhui(){
      this.$router.go(-1)
    },
    ChoiceClick(i){
      this.aboutIndex[i].map(item=>{
        item.act = 2
      })
    },
    changeClick(im){
      if(im.act==3){
        im.act = 1
        this.$forceUpdate()
        return false
      }
      if(im.act==2){
        im.act = 1
      }else{
        im.act = 2
      }
      this.$forceUpdate()
    },
    next(){
      if(this.index==1){
        if(this.form.movie_name==''){
          this.$message.error('请输入演出名称')
          return false
        }
        if(this.form.type==''){
          this.$message.error('请选择分类')
          return false
        }

        if(this.form.site_img==''){
          this.$message.error('请上传场地示意图')
          return false
        } 
        if(this.form.img==''){
          this.$message.error('请上传封面')
          return false
        } 
        if(this.form.is_refund==1){
          if(this.form.minute==''){
            this.$message.error('可退时,请输入开演前多少分')
            return false
          }
        }
        this.nxt = '上一步'
        this.index = 2
        let imgs = ''
        this.form.imgs.map(item=>{
          imgs += item + ','
        })
        this.form.imgs = imgs.slice(0,-1)
        return false
      }
      if(this.index==2){
        if(this.tableData.length==0){
          this.$message.error('请添加区域')
          return false
        }
        this.movie_area_idSeve = this.movie_area_idSeve.slice(0,-1)
        this.showtimes.map(item=>{
          for(let i =0;i<item.movie_area_ids.length;i++){
            if(this.movie_area_idSeve==item.movie_area_ids[i]){
              item.movie_area_ids.splice(i,1)
              return false
            }
          }
        })
        this.movie_area_idSeve = ''
         this.index = 3 
          this.nxt = '上一步'
         this.text = '保存'
         return false
      }
      if(this.index==3){
        for(let i=0;i<this.showtimes.length;i++){
          if(this.showtimes[i].time==''){
            this.$message.error(`请设置第${i+1}场次时间`)
            return false
          }
        }
        this.showtimes.map(item=>{
          item.id = ''
          if(item.movie_area_ids){
            item.movie_area_ids.map(itm=>{
              item.id += itm + ','
            })
          }
          item.movie_area_ids = item.id.slice(0,-1)
        })
        this.form.showtimes = this.showtimes 
        if(this.$route.query.id){
          this.form.id = this.$route.query.id
          updateMovie(this.form).then(res=>{
            if(res.data.status=='ok'){
              this.$message.success('修改成功')
              this.$router.go(-1)
            }else{
              this.$message.error(res.data.msg)
            }
          })
        }else{
          addMovie(this.form).then(res=>{
            if(res.data.status=='ok'){
              this.$message.success('添加成功')
              this.$router.go(-1)
            }else{
              this.$message.error(res.data.msg)
            }
          })
        }
      }
    },
    resurl(response){
      this.form.img = response
    },
    attachUploadSuccess(response){
      this.form.site_img = response.result
    },
    attachUpload(response, file, fileList){
      console.log(response, file, fileList)
      this.form.imgs = []
      this.transDetImgList = fileList
      this.transDetImgList.map(item=>{
        if(item.response.result){
          this.form.imgs.push(item.response.result)
        }else{
          this.form.imgs.push(item.url)
        }
      })
      console.log(this.form.imgs)
    },
    handleRemove(file) {
      console.log(file)
      this.transDetImgList.map((item,index)=>{
        if(item.url==file.url){
          this.transDetImgList.splice(index,1)
        }
        if(item.name==file.name&&item.name){
          console.log(item.name)
          this.transDetImgList.splice(index,1)
        }
      })
      this.form.imgs = []
      this.transDetImgList.map(item=>{
        if(item.response.result){
          this.form.imgs.push(item.response.result)
        }else{
          this.form.imgs.push(item.url)
        }
      })
      console.log(this.form.imgs)
    },
      // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    },
  }
}
</script>
<style lang="less" scoped>
.boxs{
  background: #fff;
  padding: 0 2rem 2rem 2rem;
  box-sizing: border-box;
  height: 89vh;
  display: flex;
  flex-direction: column;
  .boxs_title{
    padding: 1.8rem 0;
    box-sizing: border-box;
    // position: relative;
    background: #fff;
    position: sticky;
    top: 0;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #E5E5EA;
    >span{
      color: #000000;
      font-size: 2rem;
      font-weight: 600;
    }
    img{
      position: absolute;
      right: 2rem;
      top: 50%;
      transform: translate(-50%,0);
      cursor: pointer;
      width: 1.8rem;
      height: 1.8rem;
    }
  }
  .box{
    padding: 2rem 0;
    box-sizing: border-box;
    width:85rem;
    margin: 0 auto;
    .title_tabs{
      display: flex;
      justify-content: center;
      align-items: center;
      div{
        background: #D9D9D9;
        width: 11rem;
        height: 4rem;
        border-radius: 0.4rem;
        display: flex;
        justify-content: center;
        color: #fff;
        align-items: center;
        margin-right: 2rem;
        cursor: pointer;
        font-size: 1.4rem;
      }
      .active{
        background: #246DEB;
      }
    }
    .form_box{
      margin-top: 2rem;
      .flex_state{
        display: flex;
        align-items: center;
        >span{
          color: #FF4D4F;
          font-size: 1.4rem;
          display: block;
          margin: 0 0 24px 2rem ;
        }
      }
      .flex{
        display: flex;
        align-items: center;
        ::v-deep .el-date-editor,::v-deep .el-select{
          width: 29.5rem;
        }
        >span{
          color: #FF4D4F;
          font-size: 1.4rem;
          line-height: 1.4rem;
          display: block;
          margin-left: 2rem;
          margin-top: 6rem;
        }
      }
      ::v-deep .el-upload {
        border-radius: 4px;
        border: 1px solid #E5E5EA;
        background: #FFF;
        width: 23rem;
        height: 100%;
        cursor: pointer;
        position: relative;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width:100%;
        height: 100%;
        line-height: 13rem;
        text-align: center;
      }
      .addcc{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 4rem;
        div{
          width: 10rem;
          height: 4rem;
          color: #246DEB;
          border: 1px solid #246DEB;
          font-size: 1.4rem;
          border-radius: 0.4rem;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }
    }
 
  }
  .index_two_box{
    width: 100%;
    height: 26.2rem;
    border: 1px solid #E5E5EA;
    border-radius:0.4rem;
    padding: 2rem;
    margin-bottom: 3rem;
    box-sizing: border-box;
    .times{
      display: flex;
      align-items: center;
      >span{
        color: #666666;
        font-size: 1.4rem;
      }
      ::v-deep .el-date-editor {
        margin-left: 2rem;
        width:80%;
      }
      
    }
    .cheche_box{
      margin-top: 3rem;
      display: flex;
      &:nth-child(3){
        .text{
          margin-top: 0.7rem;
        }
      }
      .text{
        color: #666666;
        font-size: 1.4rem;
      }
      .checkbox_true{
        flex: 1;
        margin-left: 2rem;
        ::v-deep .el-checkbox{
          margin-bottom: 2rem;
        }
      }
      .radio_box{
        margin-left: 2rem;
        display: flex;
        align-items: center;
        ::v-deep .el-input{
          width: 10rem;
          margin-left: 1rem;
        }
        .baifen{
          margin-left: 1rem;
          color: #666666;
          font-size: 1.4rem;
        }
        .total{
          color: #FF4D4F;
          font-size: 1.4rem;
          margin-left: 2rem;
        }
      }
    }
  }
}
.position{
  display: flex;
  flex: 1;
  >div{
    height: 100%;
    // &:nth-child(1){
    //   width: 20rem;
    //   margin-left: 2rem;
    //   background: #D4E3FA;
    //   border-radius: 0.4rem;
    //   padding: 1rem 0;
    //   box-sizing: border-box;
    //   >div{
    //     width: 100%;
    //     height: 5.2rem;
    //     line-height: 5.2rem;
    //     padding:0 2rem;
    //     box-sizing: border-box;
    //     color: #246DEB;
    //     font-size: 1.4rem;
    //     cursor: pointer;
    //   }
    //   .position_active{
    //     background: #246DEB;
    //     color: #fff;
    //   }
    // }
    &:nth-child(1){
      width: 110rem;
      margin-left: 2rem;
      border: 1px solid #E5E5EA;
      border-radius: 0.4rem;
      position: relative;
      .absolute{
        background: #F7F7FA;
        width: 2.5rem;
        padding: 2.5rem 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        border-radius: 1.5rem;
        position: absolute;
        left: 4rem;
        top: 50%;
        transform: translate(0,-50%);
        div{
          height: 3rem;
          width: 100%;
          text-align: center;
          cursor: pointer;
        }
      }
      .position_box{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction:column ;
        justify-content: center;
        align-items: center;
        .title_name{
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img{
            width: 34.5rem;
            height: 1.4rem;
          }
          span{
            color: #246DEB;
            margin-top: 2.4rem;
            font-size: 2.2rem;
          }
        }
        .content{
          position: relative;
          margin-top: 4rem;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .gezi_boxs{
            display: flex;
            margin-bottom: 0.2rem;
            div{
              width: 3rem;
              height: 3rem;
              border: 1px solid #B2B2B2;
              background: #F7F7FA;
              border-radius: 0.4rem;
              margin-left: 0.2rem;
              display: flex;
              justify-content: center;
              color: #666666;
              font-size: 1.2rem;
              align-items: center;
              cursor: pointer;
            }
            .SelectCss{
              background: #246DEB;
              color: #fff;
            }
            .already{
              background: #D4E3FA;
              color: #093F93;
              border: 1px solid #093F93;
            }
          }
        }
      }
    }
    &:nth-child(2){
      margin-left: 2rem;
      background: #F7F7FA;
      border-radius: 00.4rem;
      flex: 1;
      padding: 3rem;
      box-sizing: border-box;
      .names{
        display: flex;
        align-items: center;
        >span{
          color: #666666;
          font-size: 1.6rem;
          display: block;
          width: 10rem;
          text-align: right;
        }
        >span{
          &:nth-child(3){
            display: block;
            width:2rem;
          }
        }
        ::v-deep .el-input{
          flex: 1;
        }
      }
      .types{
        display: flex;
        margin-top: 2rem;
        >span{
          color: #666666;
          font-size: 1.6rem;
          display: block;
          width: 10rem;
          text-align: right;
        }
        >div{
          margin-left: 2rem;
          flex: 1;
          display: flex;
          flex-direction: column;
          >div{
            color: #000000;
            &:nth-child(n+2){
              margin-top: 2rem;
            }
            &:nth-child(2){
              ::v-deep .el-input{
                width: 10rem;
              }
              >span{
                margin-left: 1rem;
              }
            }
          }
        }
      }
      .nums{
        margin-top: 3rem;
        display: flex;
        align-items: center;
        >span{
          font-size: 1.4rem;
          &:nth-child(1){
            color: #666666;
            display: block;
            width: 10rem;
            text-align: right;
          }
        }
        ::v-deep .el-input{
          width: 10rem;
        }
        .yuan{
          margin-left: 1rem;
          color: #666666;
        }
        .form_text{
          color: #0059EF;
        }
        .spin_form_tex{
          color: #666666;
        }
      }
    }

  }
}
.button_btns{
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 4rem;
      >div{
        width: 10rem;
        height: 4rem;
        border-radius: 0.4rem;
        color: #FFF;
        font-size: 1.4rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        &:nth-child(1){
          background: #D9D9D9;
        }
        &:nth-child(2){
          background: #246DEB;
          margin-left: 2rem;
        }
      }
}
.two_btns{
  display: flex;
  justify-content: flex-end;
  >div{
    cursor: pointer;
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    &:nth-child(1){
      border: 1px solid #246DEB;
      color: #246DEB;
      margin-right: 2rem;
    }
    &:nth-child(2){
      color: #E74C3C;
      border: 1px solid #E74C3C;
    }
  }
 
  
}
.table_box{
  margin-top: 2rem;
  .operation{
    display: flex;
    align-items: center;
    .add_bianji{
      color: #246DEB;
      font-size: 1.4rem;
      margin-right: 2rem;
      cursor: pointer;
    }
    .detele{
      color: #E74C3C;
      font-size: 1.4rem;
      cursor: pointer;
    }
  }
}
/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
.active_id{
  visibility: hidden;
}
.itemBtnS{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4rem;
  padding-bottom: 4rem;
  box-sizing: border-box;
  div{
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:nth-child(1){
      color: #246DEB;
      border: 1px solid #246DEB;
      margin-right: 2rem;
    }
    &:nth-child(2){
      color: #fff;
      background: #246DEB;
    }
  }
}
.ali_items{
  display: flex;
  align-items: center;
  height: 4rem;
  .el-input{
      width: 10rem !important;
      margin: 0 1rem;
    }
  >span{
    color: #000000;
    font-size: 1.4rem;
    white-space: nowrap;
  }
}

.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  >div{
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 1.4rem;
    cursor: pointer;
    margin-top: 4rem;
    &:nth-child(1){
      background: #D9D9D9;
    }
    &:nth-child(2){
      background: #246DEB;
      margin-left: 2rem;
    }
  }
}
.nums_btns{
  width: 10rem;
  height: 4rem;
  border-radius: 0.4rem;
  border: 1px solid #246DEB;
  font-size: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 2rem;
  color: #246DEB;
  cursor: pointer;
}
::v-deep .el-select{
  width: 100%;
}
.active_showtimes{
  flex: 1;
}
.content_boxs{
  overflow: auto;
}
</style>